import { useCallback } from 'react';
import type { CoverTextBox } from 'fym-shared/src/music24/coverDoc';
import { useCoverEditor } from '../CoverEditorContext';

/**
 * Changes fields of one text box. With `field`, the changes of one control are one Undo step (a
 * slider move sends many values).
 */
export function useTextPatch(boxId: string) {
  const { dispatch } = useCoverEditor();
  return useCallback(
    (patch: Partial<Omit<CoverTextBox, 'id'>>, field?: string) =>
      dispatch({
        type: 'updateText',
        id: boxId,
        patch,
        coalesce: field === undefined ? undefined : `text:${boxId}:${field}`,
      }),
    [boxId, dispatch]
  );
}
